import { gql } from '@apollo/client';

export default gql`
  mutation updateRetype(
    $_id: String
    $branch: String
    $disabled: Boolean
    $additionId: String
    $name: String
    $nameAr: String
    $reType: Int
    $hidefromlist: Boolean
    $desc: String
    $color: String
  ) {
    updateRetype(
      _id: $_id
      branch: $branch
      disabled: $disabled
      additionId: $additionId
      name: $name
      nameAr: $nameAr
      reType: $reType
      hidefromlist: $hidefromlist
      desc: $desc
      color: $color
    ) {
      ok
      message
      data
      error
    }
  }
`;
